import {useTranslation} from '@wix/yoshi-flow-editor'
import React, {useCallback, useEffect} from 'react'
import {usePrevious} from '../../../../../../../../commons/hooks/use-previous'
import {isPlaceReservableAsWhole} from '../../../../../selectors/seating/place'
import {checkDonationError} from '../../../../../services/donations'
import {DONATION_ERROR} from '../../../../../types'
import {DonationInput} from '../../../../donation-input'
import {TicketDonationProps} from './interfaces'
import {classes} from './ticket-donation.st.css'

export const TicketDonation = ({
  place,
  error,
  addPlaceDonation,
  setPlaceDonationError,
  showAccessibilityMode,
  placeKey,
  chooseSeatMode,
  chooseMultipleSeatsMode,
}: TicketDonationProps) => {
  const {t} = useTranslation()

  const {ticket, donation} = place
  const previousShowAccessibilityMode = usePrevious(showAccessibilityMode)
  const wholeTable = isPlaceReservableAsWhole(place)

  useEffect(() => {
    if (previousShowAccessibilityMode !== showAccessibilityMode) {
      if (error === DONATION_ERROR.EMPTY_DONATION) {
        setPlaceDonationError({placeId: place.id, error: undefined})
      }
    }
  }, [showAccessibilityMode, previousShowAccessibilityMode, error])

  const onChange = useCallback(
    newDonation => {
      if (error) {
        setPlaceDonationError({placeId: place.id, error: undefined})
      }
      addPlaceDonation({placeId: place.id, donation: newDonation})
    },
    [error, setPlaceDonationError, addPlaceDonation, place.id],
  )

  const onBlur = useCallback(() => {
    if (!chooseSeatMode && !chooseMultipleSeatsMode) {
      const newError = checkDonationError(ticket, donation, {
        excludeErrors: [DONATION_ERROR.EMPTY_DONATION],
      })
      if (newError) {
        setPlaceDonationError({placeId: place.id, error: newError})
      }
    }
  }, [ticket, donation, setPlaceDonationError, place.id])

  return (
    <DonationInput
      key={placeKey} // remount on mode change to sync value
      label={wholeTable ? t('tickets.donationInputLabel.wholeTable') : undefined}
      ticket={ticket}
      onChange={onChange}
      onBlur={onBlur}
      value={donation}
      error={error}
      className={classes.root}
      ignoreMinimum={chooseSeatMode || chooseMultipleSeatsMode}
    />
  )
}
